import React, { useEffect, useState } from "react";
import "./Login.css";
import { useOktaAuth } from "@okta/okta-react";
import { toast } from "react-toastify";
import axios from "axios";
import JobsLogo from "../../../Assets/JobsOhioLogo.jpeg";
import atlaschatlogo from "../../../Assets/Atlas-Logo.svg";
import { authClient, isOktaDisabled, devEmail } from "../../../Utils/Common";
import Checkbox from "@mui/material/Checkbox";
import {
  APIUrlThree,
  GetUserId,
  SetOktaAuthData,
  SetUserId,
} from "../../../Utils/Utils";
import { useNavigate, useLocation } from "react-router-dom";
const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const auth = useOktaAuth();
  const loggingIn = (e) => {
    authClient?.token
      .getWithRedirect({
        responseType: ["token", "id_token"],
        state: "defaultrandomstring",
      })
      .catch(function (err) {
        console.error("Error OKTA login redirect", err);
      });
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const [showMore, setShowMore] = useState(false);
  const [CheckboxSelected, setCheckboxSelected] = useState(false);
  const loggingOut = async () => {
    try {
      const email = auth.authState?.idToken?.claims?.email;
      if (!email) {
        toast.error("Cannot get user email for session report.");
      } else {
        await axios.get(
          `${APIUrlThree}/generate_last_session_report?user_email=${encodeURIComponent(
            email,
          )}`,
        );
      }
    } catch (err) {
      console.error("Session report API error:", err);
      toast.error("Failed to generate session report.");
    } finally {
      await auth.oktaAuth.signOut();
    }
  };

  const handleReadMore = () => {
    setShowMore(!showMore);
  };
  const DisableLogin = () => {
    if (CheckboxSelected === false) {
      toast.error("Please tick the checkbox to Login");
      return false;
    }
    return true;
  };
  useEffect(() => {
    const fromPath =
      location.state?.from?.pathname || location.state?.from || "/dashboard";

    // If user is already logged in (according to our app state), don't show login page
    // and instead move them to their destination or dashboard.
    if (GetUserId() && !isOktaDisabled) {
      navigate(fromPath);
      return;
    }

    // Clear session-specific storage to prepare for a new login.
    // We do this before setting the new redirectPath.
    window.localStorage.clear();
    window.sessionStorage.clear();
    sessionStorage.setItem("redirectPath", fromPath);

    if (isOktaDisabled) {
      const email = devEmail || "developer@example.com";
      const fakeAuth = {
        user: {
          profile: {
            login: email,
            email: email,
            firstName: "Dev",
            lastName: "User",
          },
        },
        isAuthenticated: true,
      };
      SetOktaAuthData("auth", fakeAuth);
      localStorage.setItem("email", email);
      SetUserId("userId", 1);

      // Short delay to ensure storage is set before navigation
      setTimeout(() => {
        const path = sessionStorage.getItem("redirectPath") || "/dashboard";
        sessionStorage.removeItem("redirectPath");
        navigate(path);
      }, 100);
    }
  }, []);

  const [tabletOrientation, setTabletOrientation] = useState(null);

  useEffect(() => {
    const portraitQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );

    const landscapeQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)",
    );

    const updateOrientation = () => {
      if (portraitQuery.matches) {
        setTabletOrientation("portrait");
      } else if (landscapeQuery.matches) {
        setTabletOrientation("landscape");
      } else {
        setTabletOrientation(null); // not a tablet
      }
    };

    updateOrientation(); // initial

    portraitQuery.addEventListener("change", updateOrientation);
    landscapeQuery.addEventListener("change", updateOrientation);

    return () => {
      portraitQuery.removeEventListener("change", updateOrientation);
      landscapeQuery.removeEventListener("change", updateOrientation);
    };
  }, []);

  return (
    <>
      <section className="login-section-main">
        <div className="section-login-after-main">
          <div className="logo-login-page">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              {" "}
              <img src={JobsLogo} alt="logo" className="logo-login" />
              <img
                src={atlaschatlogo}
                alt="Atlas"
                className="logo-login"
              />
            </div>
          </div>
          <div className="login-card-main">
            <div className="login-card-content-section">
              <div className="heading-content-section">
                <div className="logo-login-page-tab">
                 <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "20px",
              }}
            >
              {" "}
              <img src={JobsLogo} alt="logo" className="logo-login" />
              <img
                src={atlaschatlogo}
                alt="Atlas"
                className="logo-login"
              />
            </div>
                </div>

                <h2>Login with Okta</h2>
                <div className="Useragreement">
                  <p
                    style={{ fontSize: tabletOrientation ? "12px" : "" }}
                    className="Login-screen-agree-heading"
                  >
                    User Agreement: For Authorized Use Only
                  </p>
                </div>

                <div className="login-screen-hide-data">
                  <p>
                    The data and information contained in this portal are
                    CONFIDENTIAL and strictly intended for official JobsOhio
                    INTERNAL USE only.{" "}
                    <span
                      className="login-page-reacd-more"
                      onClick={handleReadMore}
                    ></span>
                  </p>
                  <div className="login-screen-hide-data">
                    <p>
                      In order to access the JobsOhio Intelligence (“JOI”)
                      portal and Atlas Chat, and use the data and information
                      contained in it, you must be an Authorized User. For
                      purposes of this User Agreement, an “Authorized User” is a
                      JobsOhio employee who has received prior written
                      authorization from JobsOhio’s President and Chief
                      Executive Officer, Chief Financial Officer or the Senior
                      Director of Enterprise Analytics to access the JOI
                      portal.{" "}
                    </p>
                    <p>
                      The information contained in the JOI portal and provided
                      by Atlas Chat is not for external distribution or data
                      monetization for profit. Authorized Users should only
                      share information and data from the JOI portal and Atlas
                      Chat with other Authorized Users. The data and information
                      contained in the JOI portal and Atlas Chat shall not be
                      used, reproduced, distributed, or communicated to any
                      unauthorized persons, external stakeholders, or other
                      third parties.{" "}
                    </p>
                    <p>
                      All use of the JOI portal and Atlas Chat is monitored for
                      security and administrative purposes. When you access this
                      portal, you are consenting to such monitoring. Use of the
                      JOI portal and Atlas Chat in violation of these terms is
                      strictly prohibited and constitutes a violation of the
                      JobsOhio Standards of Conduct and the JobsOhio Employee
                      Handbook.{" "}
                    </p>
                    <p>
                      In the rare event of a data sync issue due to timing or
                      permission constraints (affecting approximately 1% of
                      cases), our support team is available to review your case
                      and provide personalized assistance. For questions or
                      support, please email{" "}
                      <a
                        href="mailto:enterprisedata@jobsohio.com"
                        className="enterprice-text-login"
                      >
                        enterprisedata@jobsohio.com
                      </a>
                    </p>
                    <p>
                      By checking this box and clicking “login” below, you are
                      agreeing to the terms and conditions set forth above.{" "}
                      <span
                        className="login-page-reacd-more"
                        onClick={handleReadMore}
                      ></span>
                    </p>
                  </div>
                </div>
                <div className="Login-screencheckbox">
                  <Checkbox
                    {...label}
                    checked={CheckboxSelected}
                    onChange={(e) => setCheckboxSelected(e.target.checked)}
                    size="small"
                  />
                  <p
                    style={{
                      fontSize: tabletOrientation ? "14px" : "",
                      color: tabletOrientation ? "#4B5563" : "",
                      opacity: tabletOrientation ? "100%" : "",
                      fontWeight: tabletOrientation ? "bold" : "",
                    }}
                  >
                    I agree to the above and wish to continue
                  </p>
                </div>

                <form onSubmit={loggingIn}>
                  <div className="login-button-section">
                    {!CheckboxSelected ? (
                      <button
                        type="button"
                        onClick={DisableLogin}
                        className="disablebutton"
                      >
                        Login
                      </button>
                    ) : (
                      <button type="button" onClick={loggingIn}>
                        Login
                      </button>
                    )}
                  </div>
                  <div className="login-button-section-okta">
                    {auth.authState?.isAuthenticated ? (
                      <button type="submit" onClick={loggingOut}>
                        Logout
                      </button>
                    ) : null}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Login;
